export default "__VITE_ASSET__BbJ7b$w$__"